import React from 'react';

import classnames from 'classnames/bind';
import styles from './interviewLocation.module.scss';
const cx = classnames.bind(styles);

interface InterviewLocationProps {
  location: string;
}

const InterviewLocation = ({ location }: InterviewLocationProps) => {
  if (!location) return null;

  return (
    <>
      <span className={cx('info')}>면접 장소</span>
      <strong className={cx('location')}>{location}</strong>
    </>
  );
};

export default InterviewLocation;
